import type { GetProjects200PageAllOf } from './getProjects200PageAllOf';
import type { GetProjects200PageAllOfThree } from './getProjects200PageAllOfThree';

export type GetProjects200Page = GetProjects200PageAllOf & GetProjects200PageAllOfThree;
